import { Badge } from '../../../../interfaces/users.interface';
import { Workflow } from '../../../../interfaces/workflow.interface';
import { getBadgeRank } from '../../../../services/badge';
import { wfHierarchy } from '../../../../services/workflow';

/** Orders a site's workflows as its row presents them: non-expired badge, then hierarchy, then newest. */
export function sortSiteWorkflowsForDisplay(workflows: Workflow[]): Workflow[] {
  return [...workflows].sort((a, b) => {
    const badgeRankA = getBadgeRank(a.badges as Badge[]);
    const badgeRankB = getBadgeRank(b.badges as Badge[]);
    if (badgeRankA !== badgeRankB) return badgeRankB - badgeRankA;

    const statusDiff = wfHierarchy.indexOf(b.status as typeof wfHierarchy[number])
      - wfHierarchy.indexOf(a.status as typeof wfHierarchy[number]);
    if (statusDiff !== 0) return statusDiff;

    return b.id - a.id;
  });
}

/** The workflow a site's row represents; under a filter, the best of those that matched. */
export function selectDisplayWorkflow(workflows: Workflow[], statusFilter?: string): Workflow | undefined {
  const candidates = statusFilter
    ? workflows.filter((workflow) => workflow.displayStatus?.status === statusFilter)
    : workflows;
  return sortSiteWorkflowsForDisplay(candidates)[0];
}

/** The questionnaires the details panel lists; narrowing to nothing falls back to the full list. */
export function visibleSiteWorkflows(workflows: Workflow[], statusFilter?: string): Workflow[] {
  if (!statusFilter) return workflows;
  const matched = workflows.filter((workflow) => workflow.displayStatus?.status === statusFilter);
  return matched.length ? matched : workflows;
}

/** Ids of the sites holding at least one questionnaire in `status`. */
export function siteIdsWithWorkflowStatus(workflows: Workflow[], status: string): number[] {
  const siteIds = new Set<number>();
  workflows.forEach((workflow) => {
    if (workflow.site && workflow.displayStatus?.status === status) siteIds.add(workflow.site);
  });
  return [...siteIds];
}
